import { request, fantyi, weixin } from "./request";
import store from "@/store";
import qs from "qs";
import axios from "axios";
import md5 from "js-md5";

export default {
  // login

  // 登录
  userlogin(userCode, password) {
    return request({
      url: "/ffs/auth/login?userCode=" + userCode + "&password=" + password,
      method: "POST",
      data: {
        userCode,
        password,
      },
    });
  },

  // 微信登录
  userwechatlogin(code) {
    return request({
      url: "/ffs/auth/wechat/login?code=" + code,
      method: "POST",
    });
  },

  // 绑定微信
  wechatbind(openId, unionId, wechatName, wechatAvater) {
    return request({
      url:
        "/ffs/auth/wechat/bind?openId=" +
        openId +
        "&unionId=" +
        unionId +
        "&wechatName=" +
        wechatName +
        "&wechatAvater=" +
        wechatAvater,
      method: "POST",
    });
  },

  // 解绑微信
  wechatbindunbind(unionId) {
    return request({
      url: "/ffs/auth/wechat/unbind?unionId=" + unionId,
      method: "POST",
    });
  },

  // 解绑公众号
  unbinduser() {
    return request({
      url: "/ffs/mp/unbind-user",
      method: "POST",
    });
  },

  // 发送验证码验证码
  sendSmsCaptcha(telephone) {
    return request({
      url: "/ffs/auth/password/reset/sendSmsCaptcha?phoneNumber=" + telephone,
      method: "POST",
    });
  },

  // 重置密码
  resetpwd(telephone, password, verifyCode) {
    return request({
      url:
        "/ffs/auth/password/reset?phoneNumber=" +
        telephone +
        "&password=" +
        password +
        "&verifyCode=" +
        verifyCode,
      method: "POST",
    });
  },

  // 用户归属租户列表
  tenantlist(userCode) {
    return request({
      url: "/ffs/user/gettenantinfo/" + userCode,
      method: "GET",
    });
  },

  // 单位信息
  gettenantinfo(tenantId) {
    return request({
      url: "/ffs/tenantinfo/" + tenantId,
      method: "GET",
    });
  },

  // 用户单位信息(微信)
  gettenantuserinfo(tenantId, userCode) {
    return request({
      url: "ffs/sysdata/tenantuser/" + tenantId + "/" + userCode,
      method: "GET",
    });
  },

  // 用户个人信息
  getuserinfo(tenantId, userCode) {
    return request({
      url: "/ffs/user/" + tenantId + "/getone",
      method: "GET",
      params: {
        userCode,
      },
    });
  },

  // 客户服务商列表（包含余额）
  getbranchinfo(tenantId) {
    return request({
      url: "ffs/branch/" + tenantId + "/search",
      method: "GET",
      params: {
        tenantId,
        pageNum: 1,
        pageSize: 1000,
      },
    });
  },

  // 当前租户单位员工信息列表(用这个,显示绑定微信)
  getTenanUserList(tenantId) {
    return request({
      url: "ffs/sysdata/tenantuser/" + tenantId,
      method: "GET",
    });
  },

  // 租户员工列表（用户信息）
  getemployeeList(tenantId) {
    return request({
      url: "ffs/employee/" + tenantId,
      method: "GET",
    });
  },

  //  home

  // 添加用户
  addUser(data) {
    return request({
      url: "ffs/user/" + localStorage.getItem("tenantId"),
      method: "POST",
      data,
    });
  },

  // 添加单位用户
  addTenantuser(data) {
    return request({
      url: "ffs/sysdata/tenantuser/" + localStorage.getItem("tenantId"),
      method: "POST",
      data,
    });
  },

  // 修改用户密码
  updUser(data) {
    return request({
      url: "ffs/user/" + localStorage.getItem("tenantId"),
      method: "PUT",
      data,
    });
  },

  // 删除用户和单位用户
  delUser(data) {
    return request({
      url: "ffs/user/" + localStorage.getItem("tenantId") + "/" + data.userCode,
      method: "DELETE",
    });
  },

  // price

  // 获取客户或服务商列表
  branch(branchTypes) {
    let params = {
      pageNum: 1,
      pageSize: 1000,
      branchTypes,
    };
    return request({
      url: "/ffs/branch/" + localStorage.getItem("tenantId") + "/search",
      method: "GET",
      params,
    });
  },

  // 服务商列表
  providerbmslist(pageNum, pageSize) {
    return request({
      url: "/ffs/provider-bms/list",
      method: "GET",
      params: {
        tenantId: localStorage.getItem("tenantId"),
        pageNum,
        pageSize,
      },
    });
  },

  // 业务类型树
  biztype() {
    return request({
      url: "/ffs/checkprice/biztype/tree",
      method: "GET",
    });
  },

  // 服务类型
  getBizTypeEntity(data) {
    return request({
      url: "/ffs/quote/biztype/search",
      method: "POST",
      data,
    });
  },

  // 获取国家信息
  countrylist() {
    return request({
      url: "/ffs/checkprice/country/list",
      method: "GET",
    });
  },

  // 城市邮编列表
  countrycity(params) {
    return request({
      url: "/ffs/checkprice/countrycity/search",
      method: "GET",
      params,
    });
  },

  // 城市邮编列表
  countrycitysearchpage(params) {
    return request({
      url: "/ffs/countrycity/searchpage",
      method: "GET",
      params,
    });
  },

  // 查价日志
  customerquote() {
    return request({
      url:
        "/ffs/checkprice/" +
        localStorage.getItem("tenantId") +
        "/customerquotelog",
      method: "GET",
    });
  },

  // 查发货价
  sendformula(data) {
    data.bizType ? (data.bizType = data.bizType.join(",")) : "";
    data.scanDetails.forEach((element) => {
      element.settlementWeight = element.materialWeight = element.realWeight;
    });
    return request({
      url: "/ffs/checkprice/" + localStorage.getItem("tenantId") + "/sendformula",
      method: "POST",
      data,
    });
  },

  // waybill

  // 查询字典
  appdict(type) {
    return request({
      url: "platform/appdict/ffs/" + type,
      method: "GET",
    });
  },

  // 查运单
  billManagementList(par) {
    if (!par.waybillNos) {
      delete par["waybillNos"];
    }
    if (!par.startDate) {
      delete par["startDate"];
    }
    if (!par.endDate) {
      delete par["endDate"];
    }
    let params = {
      ...par,
      tenantId: localStorage.getItem("tenantId"),
      timeType: "5",
    };
    return request({
      url: "/ffs/billManagement/clientSearch",
      method: "GET",
      params,
    });
  },

  // 轨迹查询
  getTrackList(wayBillId) {
    return request({
      url: "ffs/billManagement/tracksearch",
      method: "GET",
      params: {
        pageNum: 1,
        pageSize: 100,
        tenantId: localStorage.getItem("tenantId"),
        wayBillId,
      },
    });
  },

  // 查轨迹
  taybilltrack(wayBillId) {
    let params = {
      wayBillId,
      tenantId: localStorage.getItem("tenantId"),
      pageNum: 1,
      pageSize: 100,
    };
    return request({
      url: "/ffs/billManagement/tracksearch",
      method: "GET",
      params,
    });
  },

  // reconciliation

  // 账单按票列表
  billAdvanceAccount(params) {
    return request({
      url: "/ffs/costRecord/billAdvanceAccount",
      method: "GET",
      params,
    });
  },

  // 账单明细列表
  billAdvanceAccountall(params) {
    return request({
      url: "/ffs/costRecord/" + localStorage.getItem("tenantId") + "/sys",
      method: "GET",
      params,
    });
  },
  
  getAccountBillPage(params){
    return request({
      url: "/ffs/consignor/bill/" + localStorage.getItem("tenantId") + "/search",
      method: "GET",
      params,
    });	  
  },
  
  getAccountBillCountList(params){
    return request({
      url: "/ffs/consignor/bill/" + localStorage.getItem("tenantId") + "/count",
      method: "GET",
      params,
    });	  
  },  
  
  getWayBillPage(params){
    return request({
      url: "/ffs/consignor/waybill/" + localStorage.getItem("tenantId") + "/search",
      method: "GET",
      params,
    });	  
  },
  
  getWayBillCountList(params){
    return request({
      url: "/ffs/consignor/waybill/" + localStorage.getItem("tenantId") + "/count",
      method: "GET",
      params,
    });	  
  }, 
  
  // 账单明细客户备注
  costRecordremark(data) {
    return request({
      url: "/ffs/costRecord/" + localStorage.getItem("tenantId") + "/remark",
      method: "POST",
      data,
    });
  },

  // 对账
  confirmforbill(data, flog) {
    data.forEach(
      (item, index, arr) =>
        (arr[index] = {
          wayBillId: item.wayBillId,
          id: item.id,
          spId: item.tenantId,
          wayBillNo: item.wayBillNo,
          serialNo: item.serialNo,
          tenantConfirmed: flog,
          delete: !flog,
        })
    );
	console.log(data)
    return request({
      url:
        "/ffs/costRecord/" +
        localStorage.getItem("tenantId") +
        "/confirmforbill",
      method: "POST",
      data,
    });
  },

  // 明细对账
  confirmforbilldeat(data, flog) {
    data.forEach(
      (item, index, arr) =>
        (arr[index] = {
          wayBillId: item.wayBillId,
          id: item.id,
          branchCode: item.spId,
          wayBillNo: item.wayBillNo,
          serialNo: item.serialNo,
          tenantConfirmed: flog,
          delete: !flog,
        })
    );
    return request({
      url: "/ffs/costRecord/" + localStorage.getItem("tenantId") + "/confirm",
      method: "POST",
      data,
    });
  },

  // 加收项
  getaddFeeSubject() {
    return request({
      url:
        "/ffs/setting/" + localStorage.getItem("tenantId") + "/addFeeSubject",
      method: "GET",
    });
  },

  // 发货清单
  getscanlist(params) {
    return request({
      url: "ffs/putStorage/scanlist",
      method: "GET",
      params,
    });
  },

  // 查询branch跟进人
  getServicestaff(branchCode) {
    return request({
      url:
        "ffs/branch/" +
        branchCode +
        "/" +
        localStorage.getItem("tenantId") +
        "/" +
        "servicestaff",
      method: "GET",
      params: {
        pageNum: 1,
        pageSize: 100,
      },
    });
  },

  // 获取渠道
  getquotelist() {
    return request({
      url: "ffs/quote/" + localStorage.getItem("tenantId") + "/list",
      method: "GET",
    });
  },

  // 获取发货历史记录
  scanlist(params) {
    return request({
      url: "ffs/putStorage/scanlist",
      method: "GET",
      params,
    });
  },

  // 获取发货历史记录
  putStoragecheck(wayBillNo) {
    return request({
      url: "ffs/putStorage/check",
      method: "GET",
      params: {
        scanType: 2,
        wayBillNo,
      },
    });
  },

  // 算费
  calcFreight(branchCode, row) {
    let data = {
      scan: {
        operateType: 23,
        scanType: "2",
        branchCode: branchCode,
        quoteCode: row.quoteCode,
        destination: row.destination,
        destinationName: row.destinationName,
        pieces: row.pieces,
        realPieces: row.pieces,
        realWeight: row.settlementWeight,
        materialWeight: row.settlementWeight,
        settlementWeight: row.settlementWeight,
        valueDeclared: row.valueDeclared,
        battery: row.battery,
        batteryType: row.battery ? 1 : 0,
        goodsType: row.goodsType,
        gateDeclared: row.gateDeclared,
        weightCalcRuleMultiPieces: row.weightCalcRuleMultiPieces,
        remoted: row.remoted ? 1 : 0,
      },
    };
    return request({
      url: "ffs/putStorage/calcFreight",
      method: "POST",
      data,
    });
  },

  // 发货
  putStoragescan(branchCode, row) {
    let data = {
      tenantId: localStorage.getItem("tenantId"),
      wayBillNo: row.wayBillNo,
      scanUser: JSON.parse(localStorage.getItem("userinfo")).userCode,
      operateType: 23,
      scanType: "2",
      branchCode: branchCode,
      quoteCode: row.quoteCode,
      quoteName: row.quoteName,
      destination: row.destination,
      destinationName: row.destinationName,
      pieces: row.pieces,
      realPieces: row.pieces,
      realWeight: row.settlementWeight,
      materialWeight: row.settlementWeight,
      settlementWeight: row.settlementWeight,
      valueDeclared: row.valueDeclared,
      battery: row.battery,
      batteryType: row.battery ? 1 : 0,
      goodsType: row.goodsType,
      gateDeclared: row.gateDeclared,
      weightCalcRuleMultiPieces: row.weightCalcRuleMultiPieces,
      hintMessage: row.hintMessage,
      warning: row.warning,
      remark: row.remark,
    };
    return request({
      url: "/ffs/putStorage/scan",
      method: "POST",
      data,
    });
  },

  // 渠道对应信息
  quotecountries(quoteCode) {
    return request({
      url:
        "ffs/quote/" +
        localStorage.getItem("tenantId") +
        "/" +
        quoteCode +
        "/countries",
      method: "GET",
    });
  },

  // 当前七牛和上传token
  uploadtoken() {
    return request({
      url: "ffs/qiniu/uploadtoken/",
      method: "GET",
    });
  },

  // 通知公告单位列表
  noticeformelist({ pageNum, pageSize }) {
    return request({
      url:
        "/ffs/notice/" + localStorage.getItem("tenantId") + "/publish-for-me",
      method: "GET",
      params: {
        pageNum,
        pageSize,
      },
    });
  },

  // 报价更新单位列表
  quoteformelist() {
    return request({
      url: "/ffs/quote/" + localStorage.getItem("tenantId") + "/list",
      method: "GET",
      params: {
        // customerCode: localStorage.getItem('tenantId')
      },
    });
  },

  // 查偏远
  remoteareasearch(params) {
    return request({
      url: "ffs/checkprice/remotearea/search",
      method: "GET",
      params: {
        ...params,
        pageNum: 1,
        pageSize: 100,
      },
    });
  },

  // 服务商退回
  facilitatorReturn(data) {
    return request({
      url: "/ffs/billManagement/facilitatorReturn",
      method: "POST",
      data,
    });
  },

  // 用户订阅设置
  bizmessagesub(data) {
    return request({
      url: "/ffs/tenantuser/bizmessagesub",
      method: "POST",
      data,
    });
  },

  // 查询余额
  getspbalance(tenantId, branchCode) {
    return request({
      url: "/ffs/branch/" + tenantId + "/spbalance",
      method: "GET",
      params: {
        branchCode,
      },
    });
  },
  
  getProviderSalesMan(tenantId, providerCode){
    return request({
      url: "/ffs/consignor/" + tenantId + "/salesman",
      method: "GET",
	  params: {
		providerCode,  
	  },
    });	  
  },

  // 百度翻译appid
  getfanyi() {
    return request({
      url: "/ffs/baidu/fanyi",
      method: "GET",
    });
  },

  // 百度翻译
  translate(q, appid, appsecret) {
    let salt = new Date().getTime();
    let sign = md5(appid + q + salt + appsecret);
    return fantyi.get(
      "/trans/vip/translate?q=" +
        q +
        "&from=en&to=zh&appid=" +
        appid +
        "&salt=" +
        salt +
        "&sign=" +
        sign
    );
  },

  // 制单账号
  voucheraccount() {
    return request({
      url: "/ffs/voucher/account",
      method: "GET",
    });
  },

  // 制单账号
  countrystate() {
    return request({
      url: "/ffs/countrystate/list",
      method: "GET",
    });
  },

  // 保存制单
  voucheradd(data) {
    return request({
      url: "/ffs/voucher/add",
      method: "POST",
      data,
    });
  },

  // 制单
  vouchermake(data) {
    return request({
      url: "/ffs/voucher/make",
      method: "POST",
      data,
    });
  },

  // 查询制单信息
  vouchersearch(wayBillNo) {
    return request({
      url: "/ffs/voucher/search",
      method: "GET",
      params: {
        wayBillNo,
      },
    });
  },

  // 取渠道账号
  quoteVoucherAccount(data) {
    return request({
      url: "/ffs/voucher/quotevoucheraccount",
      method: "GET",
      data,
    });
  },

  // 微信获取code换取access_token,一次有效
  weixintoken(appid, secret, code) {
    return weixin.get(
      "/sns/oauth2/access_token?appid=" +
        appid +
        "&secret=" +
        secret +
        "&code=" +
        code +
        "&grant_type=authorization_code"
    );
  },

  // 微信获取access_token换取用户信息
  weixinuserinfo(access_token, openid) {
    return weixin.get(
      "/sns/userinfo?access_token=" + access_token + "&openid=" + openid
    );
  },

  // 货主报价列表
  consignorquote() {
    return request({
      url: "/ffs/consignor/quote/" + localStorage.getItem("tenantId") + "/list",
      method: "GET",
    });
  },

  // 关注取消报价
  consignorquotefocus(focused, data) {
    return request({
      url:
        "/ffs/consignor/quote/" +
        localStorage.getItem("tenantId") +
        "/focus?focused=" +
        focused,
      method: "POST",
      data,
    });
  },

  // 货主版报价明细
  consignorquotedetails(providerQuoteCode) {
    return request({
      url:
        "/ffs/consignor/quote/" +
        localStorage.getItem("tenantId") +
        "/" +
        providerQuoteCode +
        "/details",
      method: "GET",
    });
  },

  // 货主版报价日志
  quotelogquoteCode(providerQuoteCode) {
    return request({
      url: "/ffs/quotelog/" + providerQuoteCode + "/list",
      method: "GET",
    });
  },

  // 暂扣
  upservicestatus(data) {
    return request({
      url: "/ffs/billManagement/forcaststatus",
      method: "POST",
      data,
    });
  },

  // 特殊产品
  getspIdSpecialGoodsName(spId) {
    return request({
      url: "/ffs/setting/" + spId + "/specialGoodsName",
      method: "GET",
    });
  },

  // 单件结算重
  getSinglesettlementweight(data) {
    return request({
      url:
        "ffs/quote/" +
        localStorage.getItem("tenantId") +
        "/singlesettlementweight",
      method: "POST",
      data,
    });
  },

  // 获取扫描xx
  getSettlementweight(data) {
    return request({
      url: "ffs/quote/" + data.quoteCode + "/settlementweight",
      method: "POST",
      data,
    });
  },

  // 货主查看分类轨迹
  consignortracksearch(wayBillId) {
    return request({
      url: "ffs/consignor/tracksearch?wayBillId=" + wayBillId,
      method: "GET",
    });
  },

  // 货主查看分类轨迹
  statementfirstlegs(tenantId, wayBillId) {
    return request({
      url: "ffs/statement-firstleg/" + tenantId + "/list",
      method: "GET",
      params: { wayBillId },
    });
  },

  // 头程基础信息表
  firstleglist(tenantId) {
    return request({
      url: "ffs/firstleg/" + tenantId,
      method: "GET",
      params: {
        pageNum: 1,
        pageSize: 1000,
      },
    });
  },

  // 货主报价列表
  providerservicestaff(providerCode) {
    return request({
      url: "/ffs/consignor/" + localStorage.getItem("tenantId") + "/provider-service-staff?providerCode="+providerCode,
      method: "GET",
    });
  },

	getProviderAppSetting(providerCode) {
		return request({
			url: '/ffs/setting/' + providerCode + '/appSetting',
			method: 'GET',
		})
	}, 
   
	getDepartmentSetting(tenantId){
		return request({
			url: "/ffs/setting/" + tenantId + "/department",
			method: "GET"
		})
	},
	
    getUnrulyGoods(){
        return request({
            url: '/ffs/voucher/unruly-goods/' + localStorage.getItem("tenantId") + '/list',
            method: 'GET'
        })                 
    },	
	
	getForecastOrder(tenantId, wayBillNo){
		return request({
			url: "/ffs/consignor/" + tenantId + "/forecast-order",
			method: 'GET',
			params: {
				"wayBillNo": wayBillNo
			}
		})
	},
	
	postForecastOrder(providerCode, data){
		return request({
			url: "/ffs/consignor/" + localStorage.getItem("tenantId") + "/forecast-order?providerCode=" + providerCode,
			method: "POST",
			data
		})
	},

    getCountryVoucherRemark(countryCode){
        return request({
            url: '/ffs/countrylimitrule/' + localStorage.getItem("tenantId") + '/' + countryCode + '/remark',
            method: 'GET'
        })         
    },
		
    countryStateList(countryCode){
        return request({
            url: '/ffs/countrystate/list?countryCode=' + countryCode,
            method: 'GET',        
        })
    },	
		
    remoteList(countryCode, postCode, cityName){
        return request({
            url: '/ffs/remotearea/search?countryCode=' + countryCode + '&startCode=' + postCode + '&cityName=' + encodeURIComponent(cityName),
            method: 'GET',      
            params: {
                pageNum: 1,
                pageSize: 10
            }
        })        
    },	
	
    validateAddress(data){
		console.log(data)
        return request({
            url: '/ffs/voucher/' + localStorage.getItem('tenantId') + '/validate-address',
            method: 'POST',
            data
        })        
    },	
		
    getLabel(wayBillNo){
        return request({
            url: '/ffs/consignor/' + localStorage.getItem('tenantId') + '/label?wayBillNo=' + wayBillNo,
            method: 'GET',
            headers:{
                  'Content-Type': 'application/json'
            },            
            responseType: 'blob'
        })        
    },		
	
    getInvoice(wayBillNo){
        return request({
            url: '/ffs/consignor/' + localStorage.getItem('tenantId') + '/invoice?wayBillNo=' + wayBillNo,
            method: 'GET',
            headers:{
                  'Content-Type': 'application/json'
            },            
            responseType: 'blob'
        })        
    },	
	
};
